export const CLEARA_CATEGORIZATION_SCHEMA_VERSION = 5;
